var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.47483 12.7511L7.24983 16.5261C8.79983 18.0761 11.3165 18.0761 12.8748 16.5261L16.5332 12.8678C18.0832 11.3178 18.0832 8.80114 16.5332 7.24281L12.7498 3.47614C11.9582 2.68447 10.8665 2.25947 9.74983 2.31781L5.58316 2.51781C3.9165 2.59281 2.5915 3.91781 2.50816 5.57614L2.30816 9.74281C2.25816 10.8678 2.68316 11.9595 3.47483 12.7511Z",
    fill: "#333448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9166 10.3156C9.24208 10.3156 10.3166 9.24111 10.3166 7.91563C10.3166 6.59014 9.24208 5.51562 7.9166 5.51562C6.59112 5.51562 5.5166 6.59014 5.5166 7.91563C5.5166 9.24111 6.59112 10.3156 7.9166 10.3156Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.e9834653fad09129b9741cc0142975d3.svg";
export { ForwardRef as ReactComponent };